import PageLayout from "@common/Page";
import {
  CDMF,
  CEP,
  JDMF,
  KDMF,
  US_DMF,
  WRITTEN_CONFIRMATION,
} from "@features/productInsights/data/activeTabs";
import { useFetchProductsQuery } from "@store/master";
import {
  getCurrentYearAndMonth,
  getMonthList,
  getYearList,
} from "@utils/helpers";
import { REGULATOR_TABS } from "constant/tabs";
import { useState } from "react";

const currentYearAndMonth = getCurrentYearAndMonth();
export default function OtherInsights() {
  const [year, setYear] = useState(currentYearAndMonth.year);
  const [month, setMonth] = useState(currentYearAndMonth.month);
  const [product, setProduct] = useState(null);
  const { data } = useFetchProductsQuery({ all: true });

  return (
    <PageLayout
      tabs={REGULATOR_TABS}
      title={"Regulatory Filing"}
      onMonthChange={setMonth}
      month={month}
      onProductChange={setProduct}
      product={product}
      onYearChange={setYear}
      year={year}
      monthOptions={getMonthList()}
      yearOptions={getYearList()}
      productOptions={
        data?.data?.length
          ? data?.data.map((product) => ({
              label: `${product.name} ${product?.["isR&D"] ? "(R&D)" : ""}`,
              value: String(product.name).toLowerCase(),
            }))
          : []
      }
      drawerInputsToShow={["year", "month", "product"]}
      filtersToShow={["year", "month"]}
      useDefaultSheetNames={true}
      fetchProductsWiseData={true} // will fetch show products on contents section - true means month
      uploadUrls={{
        cep: "clean-the-cep-raw-data",
        us_dmf: "clean-the-us-dmf-raw-data",
        kdmf: "clean-the-kdmf-raw-data",
        jdmf: "clean-the-jdmf-raw-data",
        cdmf: "clean-the-cdmf-raw-data",
        wc: "clean-the-wc-raw-data",
      }}
      saveAndGenerateUrls={{
        cep: "save-and-generate-cep-data",
        us_dmf: "save-and-generate-us-dmf-data",
        kdmf: "save-and-generate-kdmf-data",
        jdmf: "save-and-generate-jdmf-data",
        cdmf: "save-and-generate-cdmf-data",
        wc: "save-and-generate-wc-data",
      }}
      redirectUrl="regulator_filling"
      fetchRawAndFinalFileUrls={{
        cep: {
          raw: "download-cep-raw-file",
          final: "download-cep-final-file",
        },
        us_dmf: {
          raw: "download-us-dmf-raw-file",
          final: "download-us-dmf-final-file",
        },
        kdmf: {
          raw: "download-kdmf-raw-file",
          final: "download-kdmf-final-file",
        },
        jdmf: {
          raw: "download-jdmf-raw-file",
          final: "download-jdmf-final-file",
        },
        cdmf: {
          raw: "download-cdmf-raw-file",
          final: "download-cdmf-final-file",
        },
        wc: {
          raw: "download-wc-raw-file",
          final: "download-wc-final-file",
        },
      }}
      subTypeId={{
        cep: CEP,
        us_dmf: US_DMF,
        kdmf: KDMF,
        jdmf: JDMF,
        cdmf: CDMF,
        wc: WRITTEN_CONFIRMATION,
      }}
      sectionProductsTypes={{
        cep: "cep",
        us_dmf: "us-dmf",
        kdmf: "kdmf",
        jdmf: "jdmf",
        cdmf: "cdmf",
        wc: "wc",
      }}
      sectionMonthsTypes={{}}
      sectionTypeValues={{
        cep: "Cep",
        us_dmf: "US DMF",
        kdmf: "KDMF",
        jdmf: "JDMF",
        cdmf: "CDMF",
        wc: "WrittenConfirmation",
      }}
      previewSelectInputFields={{}}
      previewLockInputFields={{}}
    />
  );
}
